import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { getTreehouseEligiblePath, TreehouseModel } from 'client/data/models/treehouse';

function TreehousePromotionCheckUI({ isTreehouseEligible = null, children = null, fallback = null }) {
  const [showPromo, setShowPromo] = useState(isTreehouseEligible);

  useEffect(() => {
    // checks for eligibility until eligible for current zip
    if (!showPromo) {
      // Intentional one-way synchronization as eligibility becomes available.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowPromo(isTreehouseEligible);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTreehouseEligible]);

  if (showPromo === null) {
    return null;
  }

  return showPromo ? children : fallback;
}

TreehousePromotionCheckUI.propTypes = {
  isTreehouseEligible: PropTypes.bool,
  fallback: PropTypes.node,
  children: PropTypes.node,
};

export const TreehousePromotionCheck = connectToModel(TreehousePromotionCheckUI, {
  isTreehouseEligible: bindToPath(getTreehouseEligiblePath, TreehouseModel),
});
